export function Logo({ size = 40, className = "" }) {
  return (
    <img
      src="/logo-160.png"
      alt="L’Orne Park"
      width={size}
      height={size}
      className={`rounded-full object-cover shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-logo"
    />
  );
}
